// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// ... config ...
const firebaseConfig = {
    apiKey: "AIzaSyBfmOCsNq74zxJ3veketx5x9siaLiHqVH0",
    authDomain: "arberiaexperience.firebaseapp.com",
    projectId: "arberiaexperience",
    storageBucket: "arberiaexperience.firebasestorage.app",
    messagingSenderId: "326957404910",
    appId: "1:326957404910:web:1a54a8399a455d9b6099ff",
    measurementId: "G-0RPE5JFP1Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Lazy Analytics initialization to reduce unused JS on boot
let analytics = null;
const initAnalytics = () => {
    if (typeof window !== 'undefined' && !analytics) {
        analytics = getAnalytics(app);
    }
    return analytics;
};

// Modern Persistence Setup (Multi-tab support)
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";

const db = initializeFirestore(app, {
    localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager()
    })
});

const auth = getAuth(app);
const functions = getFunctions(app);
const storage = getStorage(app);

export { app, db, initAnalytics, auth, functions, storage };
